import {NgModule} from '@angular/core';
import {HasWritePermissionDirective} from '@portal/shared/directives/has-write-permissions.directive';
import {HasNotWritePermissionsDirective} from '@portal/shared/directives/has-not-write-permissions.directive';
import {HasReadPermissionsDirective} from '@portal/shared/directives/has-read-permissions.directive';
import {HasOrgWritePermissionDirective} from "@portal/shared/directives/has-org-write-permission";
import {O360StickyHorizontalScrollDirective} from '@portal/shared/directives/o360-sticky-horizontal-scroll.directive';

@NgModule({
    declarations: [
        HasWritePermissionDirective,
        HasNotWritePermissionsDirective,
        HasReadPermissionsDirective,
        HasOrgWritePermissionDirective,
        O360StickyHorizontalScrollDirective
    ],
    exports: [
        HasWritePermissionDirective,
        HasNotWritePermissionsDirective,
        HasReadPermissionsDirective,
        HasOrgWritePermissionDirective,
        O360StickyHorizontalScrollDirective
    ]
})
export class DirectivesModule {
}
